export interface VideoInfo {
  filename: string;
  width: number;
  height: number;
  fps: number;
  total_frames: number;
  duration_seconds: number;
}

export interface CourtInfo {
  detected: boolean;
  corners_px: [number, number][] | null;
  dimensions_m: { width: number; length: number };
  homography_matrix: number[][] | null;
  confidence: number;
}

export interface PlayerFrame {
  frame: number;
  bbox: [number, number, number, number];
  center: [number, number];
  confidence: number;
}

export interface BallFrame {
  frame: number;
  position: [number, number] | null;
  confidence: number;
  interpolated: boolean;
}

export interface HeatmapData {
  grid: number[][];
  grid_size: [number, number];
  coordinate_system?: 'court' | 'pixel';
}

export type EventType = 'shot' | 'rally_start' | 'rally_end';

export interface GameEvent {
  frame: number;
  time: number;
  type: EventType;
  position?: [number, number];
  position_m?: [number, number];
  angle_change?: number;
}

export interface PlayerStats {
  frames_visible: number;
  time_visible_sec: number;
  court_coverage_pct: number;
  total_distance_px: number;
  avg_speed_px_per_sec: number;
  total_distance_m?: number;
  avg_speed_m_per_sec?: number;
  shots: number;
}

export interface AnalysisResult {
  video: VideoInfo;
  court?: CourtInfo | null;
  players: Record<string, PlayerFrame[]>;
  ball: BallFrame[];
  heatmaps: Record<string, HeatmapData>;
  events: GameEvent[];
  stats: Record<string, PlayerStats>;
}

export const PLAYER_COLORS = ['#38A169', '#3182CE', '#DD6B20', '#805AD5'];

export const EVENT_COLORS: Record<string, string> = {
  shot: '#E53E3E',
  rally_start: '#3182CE',
  rally_end: '#805AD5',
};

export function formatDuration(seconds: number): string {
  return `${Math.floor(seconds / 60)}:${String(Math.floor(seconds % 60)).padStart(2, '0')}`;
}
